var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AddEditBillingAddress',{ref:"AddEditBillingAddress",on:{"addressUpdated":_vm.onBillingAddressAdded}}),_c('AddEditShippingAddress',{ref:"AddEditShippingAddress",attrs:{"original-address":_vm.currentOrderline.Address,"should-update-orderlines":false},on:{"addressUpdated":_vm.onShippingAddressChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }